$(document).ready(function() {
    // Initialize Select2 with modified default options
    const select2Options = {
        ...CONFIG.SELECT2_OPTIONS,
        placeholder: 'Select your make' // This will be overridden per select
    };
    
    $('.select2').select2(select2Options);

    const elements = {
        make: $('#makeSelect'),
        model: $('#modelSelect'),
        year: $('#yearSelect'),
        modification: $('#modificationSelect'),
        loading: $('#loading'),
        table: $('#tirePressureTable')
    };

    const showLoading = () => elements.loading.css('display', 'flex');
    const hideLoading = () => elements.loading.css('display', 'none');

    const resetSelect = (element, disabled = true) => {
        element.val(null).trigger('change');
        element.prop('disabled', disabled);
    };

    const createTable = (response, vehicle) => {
        const data = response.data?.[0];
        
        if (!data || !data.wheels || !data.wheels.length) {
            elements.table.html('<p>No tyre pressure data available</p>');
            return;
        }

        // Create vehicle info header
        const vehicleInfo = `
            <h2>Tyre Pressure Search Results</h2>
            <p class="vehicle-info">The following tyre pressures have been found for your 
                ${vehicle.year} ${vehicle.make.toUpperCase()} ${vehicle.model.toUpperCase()} 
                ${vehicle.modification}.
            </p>
        `;

        // Process wheels data
        const tirePressureRows = [];
        
        // Process each wheel in the wheels array
        data.wheels.forEach((wheelSet, index) => {
            // Check for front tires
            if (wheelSet.front) {
                tirePressureRows.push({
                    size: wheelSet.front.tire_full || wheelSet.front.tire || 'n/a',
                    position: 'Front',
                    psi: wheelSet.front.tire_pressure?.psi || 'n/a',
                    bar: wheelSet.front.tire_pressure?.bar || 'n/a',
                    kpa: wheelSet.front.tire_pressure?.kPa || 'n/a',
                    loadIndex: wheelSet.front.load_index || 'n/a'
                });
            }
            
            // Check for rear tires
            if (wheelSet.rear && wheelSet.rear.tire_pressure?.psi && wheelSet.rear.load_index) {
                tirePressureRows.push({
                    size: wheelSet.rear.tire_full || wheelSet.rear.tire || 'n/a',
                    position: 'Rear',
                    psi: wheelSet.rear.tire_pressure?.psi || 'n/a',
                    bar: wheelSet.rear.tire_pressure?.bar || 'n/a',
                    kpa: wheelSet.rear.tire_pressure?.kPa || 'n/a',
                    loadIndex: wheelSet.rear.load_index || 'n/a'
                });
            }
        });

        const tableHTML = `
            ${vehicleInfo}
            <table>
                <thead>
                    <tr>
                        <th>Size</th>
                        <th>Position</th>
                        <th>PSI</th>
                        <th>BAR</th>
                        <th>KPA</th>
                        <th>LI</th>
                    </tr>
                </thead>
                <tbody>
                    ${tirePressureRows.map(row => `
                        <tr>
                            <td>${row.size}</td>
                            <td>${row.position}</td>
                            <td>${row.psi}</td>
                            <td>${row.bar}</td>
                            <td>${row.kpa}</td>
                            <td>${row.loadIndex}</td>
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        elements.table.html(tableHTML);
    };

    // Initial load of makes
    const initializeMakes = async () => {
        try {
            showLoading();
            console.log('Fetching makes...');
            const response = await api.getMakes();
            console.log('API Response:', response);

            // The API returns data in a specific structure, let's handle it
            const makes = response.data || response;
            
            if (!makes || !makes.length) {
                throw new Error('No makes data received');
            }

            // Clear existing options and add placeholder
            elements.make.empty().append('<option value="">Select Make</option>');

            // Add each make as an option
            makes.forEach(make => {
                const option = new Option(make.name, make.slug);
                elements.make.append(option);
            });

            // Initialize Select2
            elements.make.select2({
                ...CONFIG.SELECT2_OPTIONS,
                data: makes.map(make => ({
                    id: make.slug,
                    text: make.name
                }))
            });

        } catch (error) {
            console.error('Error loading makes:', error);
            elements.make.empty().append('<option value="">Error loading makes</option>');
        } finally {
            hideLoading();
        }
    };

    // Update the placeholders based on selection state
    const updatePlaceholders = () => {
        const make = elements.make.val();
        const model = elements.model.val();
        const year = elements.year.val();

        // Update Select2 instances with new placeholders
        elements.make.data('select2').$container.find('.select2-selection__placeholder').text('Select your make');

        if (!make) {
            elements.model.data('select2').$container.find('.select2-selection__placeholder').text('Select make first');
            elements.year.data('select2').$container.find('.select2-selection__placeholder').text('Select make first');
            elements.modification.data('select2').$container.find('.select2-selection__placeholder').text('Select make first');
        } else if (!model) {
            elements.model.data('select2').$container.find('.select2-selection__placeholder').text('Select your model');
            elements.year.data('select2').$container.find('.select2-selection__placeholder').text('Select model first');
            elements.modification.data('select2').$container.find('.select2-selection__placeholder').text('Select model first');
        } else if (!year) {
            elements.year.data('select2').$container.find('.select2-selection__placeholder').text('Select year');
            elements.modification.data('select2').$container.find('.select2-selection__placeholder').text('Select year first');
        } else {
            elements.modification.data('select2').$container.find('.select2-selection__placeholder').text('Select your modification');
        }
    };

    // Initialize the selects with proper placeholders
    const initializeSelect = (element, placeholder) => {
        element.select2({
            ...select2Options,
            placeholder: placeholder
        });
    };

    // Initialize each select with its initial placeholder
    initializeSelect(elements.make, 'Select your make');
    initializeSelect(elements.model, 'Select make first');
    initializeSelect(elements.year, 'Select make first');
    initializeSelect(elements.modification, 'Select make first');

    // Event handlers
    elements.make.on('change', async function(e) {
        const make = e.target.value;
        resetSelect(elements.model, !make);
        resetSelect(elements.year, true);
        resetSelect(elements.modification, true);
        elements.table.empty();
        
        updatePlaceholders();

        if (!make) return;

        try {
            showLoading();
            console.log('Fetching models for make:', make);
            const response = await api.getModels(make);
            console.log('Models response:', response);

            const models = response.data || response;
            
            if (!models || !models.length) {
                throw new Error('No models data received');
            }

            // Clear existing options and add placeholder
            elements.model.empty().append('<option value="">Select Model</option>');

            // Add each model as an option using slug as value
            elements.model.select2({
                ...CONFIG.SELECT2_OPTIONS,
                data: models.map(model => ({
                    id: model.slug,  // Use slug as the value
                    text: model.name // Use name for display
                }))
            });

            elements.model.prop('disabled', false);
        } catch (error) {
            console.error('Error loading models:', error);
            elements.model.empty().append('<option value="">Error loading models</option>');
        } finally {
            hideLoading();
        }
        updatePlaceholders();
    });

    elements.model.on('change', async function(e) {
        const modelSlug = e.target.value;
        const make = elements.make.val();
        resetSelect(elements.year, !modelSlug);
        resetSelect(elements.modification, true);
        elements.table.empty();

        if (!modelSlug) return;

        try {
            showLoading();
            console.log('Fetching years for make:', make, 'model:', modelSlug);
            const response = await api.getYears(make, modelSlug);
            
            const years = response.data || response;
            
            if (!years || !years.length) {
                throw new Error('No years data received');
            }

            // Clear existing options and add placeholder
            elements.year.empty().append('<option value="">Select Year</option>');

            // Sort years in descending order
            const sortedYears = [...years].sort((a, b) => b.name - a.name);

            // Add each year as an option
            elements.year.select2({
                ...CONFIG.SELECT2_OPTIONS,
                data: sortedYears.map(year => ({
                    id: year.slug.toString(),    // Use slug as the value
                    text: year.name.toString()   // Use name for display
                }))
            });

            elements.year.prop('disabled', false);
        } catch (error) {
            console.error('Error loading years:', error);
            elements.year.empty().append('<option value="">Error loading years</option>');
        } finally {
            hideLoading();
        }
        updatePlaceholders();
    });

    elements.year.on('change', async function(e) {
        const year = e.target.value;
        const make = elements.make.val();
        const model = elements.model.val();
        resetSelect(elements.modification, !year);
        elements.table.empty();

        if (!year) return;

        try {
            showLoading();
            console.log('Fetching modifications for make:', make, 'model:', model, 'year:', year);
            const response = await api.getModifications(make, model, year);
            console.log('Modifications response:', response);

            const modifications = response.data || response;

            if (!modifications || !modifications.length) {
                throw new Error('No modifications data received');
            }

            // Clear existing options and add placeholder
            elements.modification.empty().append('<option value="">Select Modification</option>');

            // Add modifications to select using just the name property
            elements.modification.select2({
                ...CONFIG.SELECT2_OPTIONS,
                data: modifications.map(mod => ({
                    id: mod.slug,
                    text: mod.name // Just use the name property directly
                }))
            });

            elements.modification.prop('disabled', false);
        } catch (error) {
            console.error('Error loading modifications:', error);
            elements.modification.empty().append('<option value="">Error loading modifications</option>');
            elements.modification.prop('disabled', true);
        } finally {
            hideLoading();
        }
        updatePlaceholders();
    });

    elements.modification.on('change', async function(e) {
        const modification = e.target.value;
        if (!modification) {
            elements.table.empty();
            return;
        }

        const make = elements.make.val();
        const model = elements.model.val();
        const year = elements.year.val();

        try {
            showLoading();
            const response = await api.getTirePressure(make, model, year, modification);
            console.log('Tire Pressure API Response:', response);
            console.log('First data item:', response.data?.[0]);
            console.log('Wheels data:', response.data?.[0]?.wheels);

            const vehicleInfo = {
                make: elements.make.find('option:selected').text(),
                model: elements.model.find('option:selected').text(),
                year: elements.year.find('option:selected').text(),
                modification: elements.modification.find('option:selected').text()
            };

            createTable(response, vehicleInfo);
        } catch (error) {
            console.error('Error loading tire pressure data:', error);
            elements.table.html('<p>Error loading tire pressure data</p>');
        } finally {
            hideLoading();
        }
    });

    // Initialize the makes dropdown
    initializeMakes();

    // Initial placeholder setup
    updatePlaceholders();
});























